import store from '@clientCommon/app/bootstrap/store';

const listKiosks = (filterValue?: string) => {
  return store.models.kiosks.async.list(filterValue);
};

export default listKiosks;
